const defaultState = {
  windowLevelData: {
    1: { description: 'Soft tissue（软组织）', window: '500', level: '40' },
    2: { description: 'Lung（肺）', window: '1500', level: '-600' },
    3: { description: 'Liver（肝脏）', window: '150', level: '90' },
    4: { description: 'Bone(骨)', window: '1500', level: '300' },
    5: { description: 'Brain（脑）', window: '80', level: '40' },
    6: { description: 'Trest', window: '1', level: '1' },
    7: { description: '', window: '', level: '' },
    8: { description: '', window: '', level: '' },
    9: { description: '', window: '', level: '' },
    10: { description: '', window: '', level: '' },
  },
  generalPreferences: {
    // language: 'en-US'
  },
};

const preferences = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_USER_PREFERENCES': {
      return Object.assign({}, state, action.state);
    }
    default:
      return state;
  }
};

export { defaultState };
export default preferences;
